// SURGE FORMS (owner 2026-11-03): a subtle screen-edge tint in the form's colour at the top tiers (V Violet Eclipse and
// up, growing to VIII Shatterlight). One fixed DOM layer under the HUD, driven per frame from main.ts off the view's
// current form; render / app side only (the sim never sees it). Respects Reduce flashing (the dim multiplier scales the
// opacity) and fades in / out over ~0.3 s so a transform never pops the whole screen.
import type { SurgeForm } from '../core/surgeForms';

export class SurgeTint {
  private el: HTMLDivElement;
  private k = 0; private hex = -1;
  constructor() {
    const el = document.createElement('div'); el.id = 'surgetint';
    // plain alpha compositing (no mix-blend-mode: a blended full-screen layer over the canvas cost ~6 ms a frame on WebGL2)
    el.style.cssText = 'position:fixed;inset:0;pointer-events:none;opacity:0;z-index:4;will-change:opacity';
    document.body.appendChild(el); this.el = el;
  }
  /** per frame: the form the hero is in (null = none), real seconds, the flash dim (FLASH.dim), whether play is live */
  update(form: SurgeForm | null, dt: number, dim: number, live: boolean): void {
    const want = live && form && form.intensity >= 0.6 ? (form.intensity - 0.6) / 0.4 : 0; // V: 0 -> VIII: 1
    this.k += (want - this.k) * Math.min(1, dt * 3.5);
    if (form) {
      const dark = form.motif === 'inferno' || form.motif === 'eclipse', hex = form.motif === 'abyss' ? form.accent : dark ? form.inner : form.outer; // black-flame forms tint with their inner glow
      if (hex !== this.hex) { this.hex = hex; const c = `#${hex.toString(16).padStart(6, '0')}`; this.el.style.background = `radial-gradient(ellipse at center, transparent 52%, ${c} 118%)`; }
    }
    const op = this.k * 0.3 * dim, q = op < 0.005 ? 0 : Math.round(op * 100) / 100; // style writes only when the value moves (no per-frame recalc)
    if (q !== this.last) { this.last = q; this.el.style.opacity = String(q); }
  }
  private last = -1;
}
